import {DateTime} from 'luxon';
import {selectIsEndDateBeforeStartDate} from '~/CreateFabricInvitation/reducers/details/selectors';
import type {FabricInvitationValidationResponse} from '~/common/FabricInvitation/types';
import {convertToIso} from '~/common/utils';

export const EMPTY_EVENT_TITLE_ERROR = 'Add event title';
export const EMPTY_HOST_NAME_ERROR = 'Add host name';
export const EMPTY_DATE_TIME_ERROR = 'Add date and time';
export const PAST_EVENT_DATE_ERROR = 'The date and time cannot be in the past';
export const END_BEFORE_START_ERROR = 'End date cannot be before start date';

export const validateTitle = (
  title: string,
  ref: HTMLElement | null
): FabricInvitationValidationResponse | null => {
  const isValid = title.trim().length;
  if (!isValid) {
    return {getMessage: () => EMPTY_EVENT_TITLE_ERROR, ref, order: 3};
  }
  return null;
};

export const validateHost = (
  hostName: string,
  ref: HTMLElement | null
): FabricInvitationValidationResponse | null => {
  const isValid = hostName.trim().length;
  if (!isValid) {
    return {getMessage: () => EMPTY_HOST_NAME_ERROR, ref, order: 4};
  }
  return null;
};

const startDateTimeBeforeToday = (startTime: string) => {
  const then = DateTime.fromISO(convertToIso(startTime));
  return then.isValid && then.diffNow('minutes').minutes < 0;
};

export const validateStartEnd = (
  start: string | null,
  end: string | null,
  ref: HTMLElement | null,
  callback?: () => void
): FabricInvitationValidationResponse | null => {
  if (!start) {
    return {
      getMessage: () => EMPTY_DATE_TIME_ERROR,
      ref,
      order: 2,
      callback,
    };
  }

  if (startDateTimeBeforeToday(start)) {
    return {
      getMessage: () => PAST_EVENT_DATE_ERROR,
      ref,
      order: 2,
    };
  }

  if (selectIsEndDateBeforeStartDate({details: {start, end}})) {
    return {
      getMessage: () => END_BEFORE_START_ERROR,
      ref,
      order: 2,
    };
  }

  return null;
};
